import { normalizeBudgetAccountNumber } from "./budgetAccountNumber.validation";
import type { BudgetCategory } from "./types";

/**
 * Suggests the next top-level account number for a new sub-category (account)
 * under a category, using Movie Magic–style `{segment}-00` headers.
 */
export function suggestNextSubCategoryAccountNumber(
  category: BudgetCategory,
  reservedAccountNumbers: Set<string>
): string {
  const topSegments = category.sub_categories
    .map((subCategory) => normalizeBudgetAccountNumber(subCategory.account_number))
    .filter((value): value is string => !!value)
    .map((value) => {
      const firstSegment = value.split("-")[0];
      return firstSegment ? Number.parseInt(firstSegment, 10) : Number.NaN;
    })
    .filter((value) => !Number.isNaN(value));

  let nextSegment = topSegments.length > 0 ? Math.max(...topSegments) + 1 : 1;
  let candidate = `${nextSegment}-00`;

  while (reservedAccountNumbers.has(candidate)) {
    nextSegment += 1;
    candidate = `${nextSegment}-00`;
  }

  return candidate;
}
